// extracted by mini-css-extract-plugin
module.exports = {"sideBarItem":"DeskMenuItem_sideBarItem__3RSIk"};